import {
  KnowledgeItemsView, KnowledgeItemsListView, KnowledgeItemsDetailView, FaqsItemsView,
} from '@/views';

const routes = {
  privatePaths: [
    {
      path: 'knowledge-items',
      component: KnowledgeItemsView,
      children: [
        {
          path: '',
          component: KnowledgeItemsListView,
          name: 'KnowledgeItemsListView',
          props: ({ query }) => ({
            text: query.text || null,
          }),
        },
        {
          path: ':id',
          component: KnowledgeItemsDetailView,
          name: 'KnowledgeItemsDetailView',
          props: ({ params }) => ({
            id: params.id,
          }),
        },
      ],
    },
    {
      path: 'soluciones',
      component: FaqsItemsView,
      children: [
        {
          path: ':resourceCi',
          component: KnowledgeItemsListView,
          name: 'FaqsListView',
          props: ({ query }) => ({
            text: query.text || null,
          }),
        },
        {
          path: ':resourceCi/:id',
          component: KnowledgeItemsDetailView,
          name: 'FaqsItemsDetailView',
          props: ({ params }) => ({
            id: params.id,
          }),
        },
      ],
    },
  ],
  publicPaths: [
    {
      path: 'knowledge-items',
      component: KnowledgeItemsView,
      props: () => ({
        publicView: true,
      }),
      children: [
        {
          path: ':id',
          component: KnowledgeItemsDetailView,
          name: 'KnowledgeItemsDetailView',
          props: ({ params }) => ({
            id: params.id,
            publicView: true,
          }),
        },
      ],
    },
  ],
};

export default routes;
